import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  box: {
    margin: '8px 16px ',
    display: 'flex',
  },
  shimmer: {
    minHeight: '45px',
    borderRadius: '4px',
    animation: '$shimmer 2s infinite',
    'animation-fill-mode': 'forwards',
    'animation-timing-function': 'linear',
    background: 'linear-gradient(to left, #ffffff0f 10%, #ffffff1f 50%, #ffffff0f 90%)',
    'background-size': '1200px 100%',
  },
  shimmerIcon: {
    flex: 1,
    'margin-right': '10px',
  },
  shimmerTitle: {
    flex: 4,
  },
  '@keyframes  shimmer': {
    '0%': {
      'background-position': '-100% 0',
    },
    '100%': {
      'background-position': '100% 0',
    },
  },
  '@keyframes  shimmer': {
    '0%': {
      'background-position': '-1200px 0',
    },
    '100%': {
      'background-position': '1200px 0',
    },
  },
}));
